/* @flow */

import { uniq } from 'ramda';
import * as marketTypes from 'src/shared/app/market/action/marketActionTypes';
import {
  createReducer,
  setRequestResultUniqAndValidate,
  invalidate,
  setFetchingState,
  unsetFetchingState,
} from 'src/shared/core/util/reducerUtils';
import * as types from 'src/shared/domain/topic/action/topicActionTypes';

const initialState = {
  isInvalidated: false,
  isFetching: false,
  isLazyFetching: false,
  result: [],
  count: null,
  next: null,
  previous: null,
};

const _lazyFetchTopicsRequest = (state: Object) => ({
  ...state,
  isLazyFetching: true,
});

const _lazyFetchTopicsSuccess = (state: Object, action: Object) => {
  const { result } = state;
  const { result: newResult, next } = action;

  return {
    ...state,
    isLazyFetching: false,
    result: uniq([...result, ...newResult]),
    next,
  };
};

const _lazyFetchTopicsFailure = (state: Object) => ({
  ...state,
  isLazyFetching: false,
});

export default createReducer(initialState, {
  [types.SIMULATE_TOPICS_FETCH]: setFetchingState,
  [types.FETCH_TOPICS_REQUEST]: setFetchingState,
  [types.FETCH_TOPICS_SUCCESS]: setRequestResultUniqAndValidate,
  [types.LAZY_FETCH_TOPICS_REQUEST]: _lazyFetchTopicsRequest,
  [types.LAZY_FETCH_TOPICS_SUCCESS]: _lazyFetchTopicsSuccess,
  [types.LAZY_FETCH_TOPICS_FAILURE]: _lazyFetchTopicsFailure,
  [types.FETCH_TOPICS_FAILURE]: unsetFetchingState,
  [marketTypes.INVALIDATE_MARKET]: invalidate,
});
